export default __webpack_public_path__ + "dcf9c0dc736595238ce59b7fb52b5c55.png";